import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=084cc710&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"
import style0 from "@/static/css/user/list.css?vue&type=style&index=0&id=084cc710&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084cc710",
  null
  
)

export default component.exports